export const ACTIONS_LOG_ACTIONS_ENUM = {
  search: 'action_log:search'
}

const actionsLogSearchEnabled = permissionIsEnabledFn => {
  return permissionIsEnabledFn(ACTIONS_LOG_ACTIONS_ENUM.search)
}

export { actionsLogSearchEnabled }
